import { calculate } from '@calculations/price/strategies/raf-fixed-market/calculate';
import { calculateTotal } from '@calculations/price/utilities/total';
import { SnapSuggestionStatus } from '@snap-types/models/common';
import {
  getQuoteLineOrThrow,
  getQuotePriceOrThrow,
} from '@ui/features/quote-builder/state/utilities/action-guards';
import { QuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

export function onProductOptionChange(
  state: QuoteBuilderStateType,
  params: {
    quoteLineUuid: string;
    quotePriceUuid: string;
  },
) {
  const quoteLine = getQuoteLineOrThrow(state, params.quoteLineUuid);
  const quotePrice = getQuotePriceOrThrow(
    state,
    params.quoteLineUuid,
    params.quotePriceUuid,
  );
  const { marketCode } = state;

  if (
    !marketCode ||
    !quoteLine.marketPrices ||
    !quoteLine.productOptions ||
    !quoteLine.craftProductOptions
  ) {
    throw new Error('Could not calculate price');
  }

  const price = calculate(
    {
      quantity: quotePrice.quantity,
      marketCode,
      marketPrices: quoteLine.marketPrices,
      productOptions: Object.values(quoteLine.productOptions),
      craftProductOptions: quoteLine.craftProductOptions,
    },
    state.calculationConfig,
  );

  if (!price) {
    throw new Error('Could not calculate price');
  }

  quotePrice.unitPrice = price.unitPrice;
  quotePrice.calculatedUnitPrice = price.unitPrice;
  quotePrice.suggestedPriceStatus = SnapSuggestionStatus.ACCEPTED;

  quotePrice.unitPriceAddition = price.unitPriceAddition ?? null;
  quotePrice.changesUnitPrice = price.changesUnitPrice;

  quotePrice.totalPrice = calculateTotal(price.unitPrice, quotePrice.quantity);

  return price;
}
